import Quill from '../core/quill';
import extend from 'extend';
import BubbleTheme, {BubbleTooltip} from './bubble';
import TextBreak from '../blots/textBreak';
import Toc from '../blots/toc';
import Excursions from '../blots/excursions';
import Divider from '../blots/divider';
import GoogleMap from '../blots/googleMap';
import Figure from '../modules/figure';
// import EmbedButtons from '../modules/embedButtons';

import TextLine from '../formats/textLine';
import Gallery from '../formats/gallery';
import Delta from "quill-delta";

BubbleTooltip.TEMPLATE = [
  '<span class="ql-tooltip-arrow"></span>',
  '<div class="ql-tooltip-editor">',
  '<input type="text" data-formula="e=mc^2" data-link="https://example.com" data-video="Embed URL">',
  '<a class="ql-close"></a>',
  '</div>',
].join('');

const CLIPBOARD_CONFIG = [
  ['div', function (node) {
    if (node.classList.contains('gallery')) {
      const images = node.querySelectorAll('img');
      return new Delta().insert({gallery: images});
    }
    if (node.dataset && node.dataset.excursions) {
      const excursions = JSON.parse(node.dataset.excursions);
      return new Delta().insert({excursions: excursions});
    }
    return new Delta();
  }],
  ['img', function (node) {
    if (node.src && sanitize(node.src, ['http', 'https', 'data'])) {
      node.src = node.src.replace(location.origin, '');
      return new Delta().insert({
        figure: {
          image: node.src,
          caption: node.alt || '',
          source: node.dataset.source || ''
        }
      });
    }
    return new Delta();
  }],
  ['video', function (node) {
    if (node.src && sanitize(node.src, ['http', 'https', 'data'])) {
      return new Delta().insert({figure: {video: node.src}});
    }
    return new Delta();
  }],
];

class ArticleTheme extends BubbleTheme {
  constructor(quill, options) {
    super(quill, options);
    
    Quill.register({
      'blots/textBreak': TextBreak,
      'blots/toc': Toc,
      'blots/excursions': Excursions,
      'blots/divider': Divider,
      'blots/googleMap': GoogleMap,
      
      // 'blots/asideContainer': AsideContainer,
      'formats/textLine': TextLine,
      'formats/gallery': Gallery,
  
      'modules/figure': Figure,
      // 'modules/embedButtons': EmbedButtons,
    });
  
    options.modules = extend({}, {
      figure: true,
      storage: true,
    }, options.modules || {});
  
    quill.on(Quill.events.SCROLL_OPTIMIZE, function (mutations) {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && !mutation.addedNodes.length && mutation.removedNodes.length) {
          let prev = mutation.previousSibling;
          let next = mutation.nextSibling;
          // if (!next && prev && prev.tagName === 'BR' && prev.className === 'inline') {
          //   let br = document.createElement('br');
          //   br.className = 'inline';
          //   mutation.target.appendChild(br);
          // } else
          if (next && prev &&
            !(prev.tagName === 'BR' && prev.className === 'inline') &&
            (next.tagName === 'BR' && next.className === 'inline') &&
            !next.nextSibling) {
            if (next.parentNode) {
              next.parentNode.removeChild(next);
            }
          }
        }
      });
    });
    
    // quill.root.classList.add('entry-content');
  }
  
  extendToolbar(toolbar) {
    super.extendToolbar(toolbar);
  
    CLIPBOARD_CONFIG.forEach(
      ([selector, matcher]) => {
        this.quill.clipboard.addMatcher(selector, matcher);
      },
    );
  }
}

ArticleTheme.DEFAULTS = extend(true, {}, BubbleTheme.DEFAULTS, {
  modules: {
    embedButtons: ['img', 'gallery', 'embed', 'toc', 'excursions', 'divider']
  }
});

function sanitize(url, protocols) {
  let anchor = document.createElement('a');
  anchor.href = url;
  let protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

export default ArticleTheme;
